// ORULO
export const ORULO_REDIRECT_URL = `${process.env.REACT_APP_IMOBPRO_ROOT_URL}/login`
export const ORULO_AUTH_URL = `https://www.orulo.com.br/oauth/authorize?client_id=${process.env.REACT_APP_ORULO_CLIENT_ID}&redirect_uri=${ORULO_REDIRECT_URL}&response_type=code`

export const maxFileSize = 5242880;
export const ORULO_END_USER_AUTH_TOKEN = "ORULO_END_USER_AUTH_TOKEN";
export const LI_AUTH_TOKEN = "LI_AUTH_TOKEN";
